import {request, serviceUrl} from "@/utils/request";

// 新增更新拓扑图信息
export function save(object) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/topology/save',
    data: object
  })
}

// 新增更新拓扑图信息
export function query(spaceId) {
  return request({
    url: serviceUrl.deviceService + '/topology/query',
    params: {spaceId: spaceId}
  })
}

// 查询拓扑图设备图片和背景图片
export function getTopologyImages() {
  return request({
    url: serviceUrl.deviceService + '/topology/getTopologyImages',
  })
}

// 保存拓扑图设备图片和背景图片
export function saveTopologyImages(obejct) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/topology/saveTopologyImages',
    data: obejct
  })
}

// 删除拓扑图设备图片和背景图片
export function deleteTopologyImages(id) {
  return request({
    url: serviceUrl.deviceService + '/topology/deleteTopologyImages',
    params: {id: id}
  })
}

// 查询运营平台网络拓扑图
export function getCategoryTopologyImages() {
  return request({
    url: serviceUrl.deviceService + '/device/category/list'
  })
}

// 新增更新svg拓扑图信息
// 空间id spaceId;
// svg拓扑图名称 name;
// svg地址 url;
export function saveSvg(object) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/topology/svg/save',
    data: object
  })
}

// 查询拓扑图设备图片和背景图片 空间id spaceId
export function getSvgTopologyImages(spaceId) {
  return request({
    url: serviceUrl.deviceService + '/topology/svg/getImages?spaceId=' + spaceId,
  })
}

// 导入拓扑图匹配
// file;
// spaceId;
// spaceName;
export function importTopology(object) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/topology/import-topology-match',
    data: object
  })
}

// 导入拓扑图开关闸
// file;
// spaceId;
// spaceName;
export function importTopologyGateway(object) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/topology/import-topology-switch',
    data: object
  })
}

// 根据设备id集合和测点id集合拿到所有数据
export function getDataByDeviceIdsAndPointIds(deviceIds, pointIds) {
  return request({
    url: serviceUrl.deviceService + '/device/measuring-point-history/getCurrentValues',
    method: 'post',
    data: {deviceIds: deviceIds, pointIds: pointIds}
  })
}

// 获取空间列表拓扑图列表
export function getSpaceTopology() {
  return request({
    url: serviceUrl.deviceService + '/topology/list'
  })
}

// 根据空间名称查询拓扑图信息
export function getTopologyBySpaceName(spaceName) {
  return request({
    url: serviceUrl.deviceService + '/topology/getBySpaceName',
    params: {spaceName: spaceName}
  })
}
